import {
  Box,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  InputLabel,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import validator from "email-validator";
import { PhoneNumberUtil } from "google-libphonenumber";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "../../../store/store";
import { LoadingButton } from "@mui/lab";
import { IAddParty } from "../../../shared/models/settings";
import { addPartyApi, createOrganizationMemberApi } from "../../../store/api/settings";
import { getUserContext } from "../../../shared/utils/utils";
import {
  ADMIN_ROLES,
  APPROVAL_NAME_MAPPING,
  PARTY_ACTIVE_STATUS,
  RELATIONSHIP_TYPE,
  ROLE_MAPPING,
} from "../../../shared/constants/constants";
import {
  ICreatePartyRelationships,
  ICreatePartyPreference,
} from "../../../shared/models/party";
import { createPartyRelationshipApi } from "../../../store/api/party";
import { fetchAllSecurityGroups, getAllRelationshipTypesApi } from "../../../store/api/common";
type Props = {
  cancelAdd: () => void;
  addUser: (reqBody: any) => void;
  handleSetError:(message:string)=>void;
  handleSetSuccess:(message:string)=>void;
};
const phoneUtil = PhoneNumberUtil.getInstance();
export const AddUser = ({ cancelAdd, addUser,handleSetError,handleSetSuccess }: Props) => {
  const settingsRfqState = useSelector((state: RootState) => state.settings);
  // const [roles,setRoles] = useState(["Buyer Admin","Buyer Approver","Accounts","Custom Role"])
  const userContext: any = getUserContext();
  const orgPartyId = userContext.orgPartyIds[0];
  // console.log(orgPartyId)
  const [name, setName] = useState({
    value: "",
    isError: false,
    errorMsg: "",
  });
  const [role, setRole] = useState({
    value: "Select Role",
    isError: false,
    errorMsg: "",
  });
  const [level, setLevel] = useState({
    value: "Select Level",
    isError: false,
    errorMsg: "",
  });
  const [email, setEmail] = useState({
    value: "",
    isError: false,
    errorMsg: "",
  });

  // Helper function to detect Gmail accounts
  const isGmailAccount = (email: string): boolean => {
    const gmailDomains = ['@gmail.com', '@googlemail.com'];
    const emailLower = email.toLowerCase();
    return gmailDomains.some(domain => emailLower.endsWith(domain));
  };
  const [phoneNumber, setPhoneNumber] = useState({
    value: "",
    isError: false,
    errorMsg: "",
  });
  const [roles, setRoles] = useState([]);
  useEffect(()=>{
    store.dispatch(fetchAllSecurityGroups()).unwrap().then((res)=>{
      if(res.status===200){
        setRoles(res.data);
      }
    })
  },[])
  const handleLevelChange = (event: SelectChangeEvent) => {
    // console.log(event.target.value)
    setLevel((prevState) => ({
      ...prevState,
      value: event.target.value,
    }));
  };
  const handleRoleChange = (event: SelectChangeEvent) => {
    // console.log(event.target.value)
    setRole((prevState) => ({
      ...prevState,
      value: event.target.value,
    }));
  };
  const validateName = (name: string) => {
    if (name.length < 2) {
      setName((prevState) => ({
        ...prevState,
        isError: true,
        errorMsg: "Please enter a valid name",
      }));
      return false;
    } else {
      setName((prevState) => ({
        ...prevState,
        isError: false,
        errorMsg: "",
      }));
      return true;
    }
  };
  const validateRole = (role: string) => {
    if (role === "Select Role") {
      setRole((prevState) => ({
        ...prevState,
        isError: true,
        errorMsg: "Please select a role",
      }));
      return false;
    } else {
      setRole((prevState) => ({
        ...prevState,
        isError: false,
        errorMsg: "",
      }));
      return true;
    }
  };
  const validateLevel = (level: string) => {
    if (level === "Select Level") {
    //   setLevel((prevState) => ({
    //     ...prevState,
    //     isError: true,
    //     errorMsg: "Please select a level",
    //   }));
    //   return false;
    // } else {
    //   setLevel((prevState) => ({
    //     ...prevState,
    //     isError: false,
    //     errorMsg: "",
    //   }));
    //   return true;
    return false
    }
    return true
  };
  const validateEmail = (email: string) => {
    if (!validator.validate(email)) {
      setEmail((prevState) => ({
        ...prevState,
        isError: true,
        errorMsg: "Please enter a valid email",
      }));
      return false;
    } else {
      setEmail((prevState) => ({
        ...prevState,
        isError: false,
        errorMsg: "",
      }));
      return true;
    }
  };
  const validatePhone = (number: string) => {
    try {
      if (phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(number))) {
        setPhoneNumber((prevState) => ({
          ...prevState,
          isError: false,
          errorMsg: "",
        }));
        return true;
      } else {
        setPhoneNumber((prevState) => ({
          ...prevState,
          isError: true,
          errorMsg: "Please enter a valid phone number",
        }));
        return false;
      }
    } catch {
      setPhoneNumber((prevState) => ({
        ...prevState,
        isError: true,
        errorMsg: "Please enter a valid phone number",
      }));
      return false;
    }
  };
  const handleAddUser = () => {
    const number = `+91${phoneNumber.value.toString()}`;
    if (
      validateName(name.value) &&
      validateRole(role.value) &&
      validateEmail(email.value) &&
      // validateLevel(level.value) &&
      validatePhone(number)
    ) {
      let personRoles:string[];
      if(validateLevel(level.value)) {
        personRoles = [role.value,level.value]
      }
      else {
        personRoles = [role.value]
      }

      // Use new organization member API
      const reqBody = {
        personName: name.value,
        personRole: personRoles,
        emailAddress: email.value,
        mobileNumber: number,
        address: "",
        city: "",
        state: "",
        pincode: ""
      };

      store.dispatch(createOrganizationMemberApi(reqBody)).unwrap().then((res: any) => {
        if(res.status===201) {
          const successMessage = res.data.message || "New organization member created successfully";
          handleSetSuccess(successMessage);
          
          // Add the new member to the list
          if (res.data.member) {
            const memberData = {
              _id: res.data.member._id,
              details: { name: res.data.member.name },
              registeredEmail: res.data.member.email,
              registeredNumber: res.data.member.mobile,
              roles: res.data.member.roles
            };
            addUser(memberData);
          }
          
          cancelAdd();
        }
        else {
          handleSetError(res.error || "Failed to create organization member");
          console.log(res.error);
        }
      }).catch((error: any) => {
        console.error("Error creating organization member:", error);
        handleSetError("Failed to create organization member. Please try again.");
      });
    }
  };
  return (
    <>
      <Box className="addUserBox">
        <Box className="addUserFormsContainer">
          <FormControl
            fullWidth
            sx={{ mt: 2 }}
            variant="standard"
            className="addUser_input_field"
          >
            <FormLabel>Name</FormLabel>
            <TextField
              id="Name"
              variant="standard"
              placeholder="Full Name"
              value={name.value}
              error={name.isError}
              helperText={name.errorMsg}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setName((prevState) => ({
                  ...prevState,
                  value: event.target.value,
                }));
              }}
              className="addUserinput_text"
            />
          </FormControl>
        </Box>
        <Box className="addUserFormsContainer">
          <FormControl
            fullWidth
            sx={{ mt: 2, width: { xs: "100%", md: "40%" } }}
            variant="filled"
            className="addUser_input_field"
          >
            <FormLabel>Role</FormLabel>
            <Select
              labelId="select-role"
              id="select-role"
              value={role.value}
              onChange={handleRoleChange}
              className={role.value === "Select Role" ? "baseSelect" : ""}
              error={role.isError}
            >
              <MenuItem value={"Select Role"} disabled>
                Select Role
              </MenuItem>
              {roles?.filter((role:any)=>!ADMIN_ROLES?.includes(role?.groupId) && !role?.groupId?.includes("VENDOR") && (!role?.partyId || role?.partyId === orgPartyId)).map((role: any, index: any) => {
                return (
                  <MenuItem value={role.groupId} key={role._id}>
                    {role.groupName}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText sx={{ color: "red" }}>
              {role.errorMsg}
            </FormHelperText>
          </FormControl>

          <FormControl
            variant="filled"
            sx={{ mt: 2, width: { xs: "100%", md: "40%" } }}
            className="addUser_input_field"
          >
            <FormLabel>Level</FormLabel>

            <Select
              labelId="select-role"
              id="select-role"
              value={level.value}
              onChange={handleLevelChange}
              className={level.value === "Select Level" ? "baseSelect" : ""}
              error={level.isError}
            >
              <MenuItem value={"Select Level"} disabled>
                Select Level
              </MenuItem>
              <MenuItem value={APPROVAL_NAME_MAPPING.L1_APPROVER}>L1</MenuItem>
              <MenuItem value={APPROVAL_NAME_MAPPING.L2_APPROVER}>L2</MenuItem>
              <MenuItem value={APPROVAL_NAME_MAPPING.L3_APPROVER}>L3</MenuItem>
              {/* <MenuItem value={APPROVAL_NAME_MAPPING.L4_APPROVER}>L4</MenuItem>
              <MenuItem value={APPROVAL_NAME_MAPPING.L5_APPROVER}>L5</MenuItem> */}
            </Select>
            <FormHelperText sx={{ color: "red" }}>
              {level.errorMsg}
            </FormHelperText>
          </FormControl>
        </Box>
        <Box className="addUserFormsContainer">
          <FormControl
            fullWidth
            sx={{ mt: 2 }}
            variant="standard"
            className="addUser_input_field"
          >
            <FormLabel>E-mail</FormLabel>
            <TextField
              id="email"
              variant="standard"
              type="email"
              placeholder="Email"
              value={email.value}
              error={email.isError}
              helperText={
                email.errorMsg || 
                (email.value && isGmailAccount(email.value) 
                  ? "Gmail account detected - user will login with Google" 
                  : email.value && !isGmailAccount(email.value) 
                  ? "Non-Gmail account - user will receive login credentials via email"
                  : ""
                )
              }
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEmail((prevState) => ({
                  ...prevState,
                  value: event.target.value,
                }));
              }}
              className="addUserinput_text"
            />
          </FormControl>
          <Box
            sx={{
              width: { xs: "100%", md: "40%" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "end",
            }}
          >
            <FormLabel className="addUserPhoneNumberLabel">
              Phone number
            </FormLabel>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                gap: "20px",
              }}
            >
              <Typography className="addUserinput_typography">+ 91</Typography>
              <FormControl
                fullWidth
                sx={{ width: "100% !important" }}
                variant="standard"
                className="addUser_input_field"
              >
                <TextField
                  id="phoneNumber"
                  variant="standard"
                  placeholder="Phone Number"
                  type="number"
                  value={phoneNumber.value}
                  error={phoneNumber.isError}
                  helperText={phoneNumber.errorMsg}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setPhoneNumber((prevState) => ({
                      ...prevState,
                      value: event.target.value,
                    }));
                  }}
                  className="addUserinput_text"
                />
              </FormControl>
            </Box>
          </Box>
        </Box>
        <Box className="addUserBtnsContainer">
          <LoadingButton
            loadingPosition="center"
            variant="contained"
            className="addNewUserBtn"
            onClick={handleAddUser}
            disabled={settingsRfqState.loading}
          >
            Add new user
          </LoadingButton>
          <Button
            variant="contained"
            className="addNewUserBtn"
            onClick={cancelAdd}
            sx={{
              backgroundColor: "#F0F0F0 !important",
              color: " #22438C !important",
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </>
  );
};
